import RepoTypeIcon from 'components/RepoTypeIcon';
import Tooltip from 'components/Tooltip';
import { useAtomValue } from 'jotai';
import React, { useState } from 'react';
import { Row, Col, Container, Card } from 'reactstrap';
import {
  BASE_URL,
  HostType,
  getHostLabel,
  getOAuthUrl,
} from 'views/sast2/helper';
import { accountsTitlesAtom } from 'views/sast2/state';

import history from '../../../../history.js';
import SelectAccountModal from '../SelectAccountModal';

import './styles.css'; // Import custom CSS file for styling

type HostCardProps = {
  repoType: HostType;
  onClick: () => void;
};

const TooltipId = 'sast-account-integration-tooltip';

const HostCards = () => {
  const [selectedHostType, setSelectedHostType] = useState<HostType>();
  const [modalOpen, setModalOpen] = useState(false);
  const accountsTitles = useAtomValue(accountsTitlesAtom);

  const hostAccounts = (hostType): [] => {
    return accountsTitles?.filter((x) => x['host_type'] === hostType);
  };

  const handleConnect = (id) => {
    setModalOpen(false);
    if (id === -1) {
      // create new account
      // console.log('create new account');
      if (selectedHostType) {
        const oauthUrl = getOAuthUrl(selectedHostType, 'new');
        if (oauthUrl) window.location.href = oauthUrl;
      }
    } else if (id > 0) {
      // console.log('redirect to repositories selection page for account ' + id);
      history.push(`/${BASE_URL}/sast?account=${id}&t=add_repos`);
      return;
    }
  };

  const onClickHandler = (hostType: HostType) => {
    const oauthUrl = getOAuthUrl(hostType, 'new');
    if (oauthUrl) {
      // check for the existing accounts
      if (hostAccounts(hostType)?.length > 0) {
        setSelectedHostType(hostType);
        setModalOpen(true);
      } else {
        window.location.href = oauthUrl;
      }
    } else {
      console.error(`${hostType} oAuth URL is not defined.`);
    }
  };

  const HostCard = ({ repoType, onClick }: HostCardProps) => {
    const title = getHostLabel(repoType);
    return (
      <Tooltip
        id={TooltipId}
        title={title}
        tooltip={`Click to Connect ${title} Account/Repositories`}
      >
        <Container
          className="d-flex justify-content-center align-items-center"
          style={{ width: '200px' }}
        >
          <Card
            className="card-chart border border-light p-3 text-center hover-shadow"
            onClick={onClick}
          >
            <span className="align-self-center mb-3">
              <RepoTypeIcon repoType={repoType} size={48} />
            </span>
            <h4 className="mb-0">{title}</h4>
          </Card>
        </Container>
      </Tooltip>
    );
  };

  return (
    <>
      <Container className="d-flex justify-content-center w-100">
        <Row className="d-flex justify-content-center align-self-center">
          <Col className="p-0">
            <HostCard
              repoType={HostType.Azure}
              onClick={() => onClickHandler(HostType.Azure)}
            />
          </Col>
          <Col className="p-0">
            <HostCard
              repoType={HostType.Github}
              onClick={() => onClickHandler(HostType.Github)}
            />
          </Col>
          <Col className="p-0">
            <HostCard
              repoType={HostType.Gitlab}
              onClick={() => onClickHandler(HostType.Gitlab)}
            />
          </Col>
          <Col className="p-0">
            <HostCard
              repoType={HostType.Bitbucket}
              onClick={() => onClickHandler(HostType.Bitbucket)}
            />
          </Col>
          {/* TODO: UNCOMMENT LATER FOR ON PREMISES */}
          {/* <Col className="p-0">
            <HostCard
              repoType={HostType.Other}
              onClick={() => alert("TODO: for on premises repositories")}
            />
          </Col> */}
        </Row>
      </Container>
      {modalOpen && selectedHostType && (
        <SelectAccountModal
          hostType={selectedHostType}
          connectedAccounts={hostAccounts(selectedHostType)}
          onConnect={handleConnect}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
};

export default HostCards;
